<template>
  <v-row dense>
    <v-col cols="12" md="6" lg="4">
      <v-list-item v-if="title || description">
        <v-list-item-content>
          <v-list-item-title v-if="title">
            {{ title }}
          </v-list-item-title>
          <v-list-item-subtitle v-if="description" class="text-wrap">
            {{ description }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col cols="12" md="6" lg="8">
      <slot />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'AdministrationSettingsCategory',

  components: {},

  props: {
    title: {
      type: String,
      required: false,
      default: null
    },
    description: {
      type: String,
      required: false,
      default: null
    }
  }
}
</script>
